export const removeFieldGrid = (container: HTMLElement, fieldName: string) => {
    const input = Array.from(container.querySelectorAll<HTMLInputElement>('input[name]'))
        .find((field) => field.name === fieldName);
    input?.closest('.MuiGrid-root, [class*="Grid"]')?.remove();
};